import { render, staticRenderFns } from "./reportDetails.vue?vue&type=template&id=6a643d59&scoped=true&"
import script from "./reportDetails.vue?vue&type=script&lang=js&"
export * from "./reportDetails.vue?vue&type=script&lang=js&"
import style0 from "./reportDetails.vue?vue&type=style&index=0&id=6a643d59&prod&lang=less&scoped=true&"
import style1 from "./reportDetails.vue?vue&type=style&index=1&id=6a643d59&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a643d59",
  null
  
)

export default component.exports